module.exports = __webpack_public_path__ + "static/img/Jack-Darling.b975513.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack-Darling.jpg
// module id = Cfva
// module chunks = 0